(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.hv-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('hv-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hv-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-hv-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-hv-count')) || 0;
        var decimals = (el.getAttribute('data-hv-count').split('.')[1] || '').length;
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = (target * eased).toFixed(decimals);
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = target.toFixed(decimals);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initTiltCards() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    var cards = document.querySelectorAll('[data-hv-tilt]');
    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(700px) rotateY(' + (x * 8) + 'deg) rotateX(' + (y * -8) + 'deg) translateY(-6px)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  function initReviewCarousel() {
    var wraps = document.querySelectorAll('[data-hv-reviews]');
    wraps.forEach(function (wrap) {
      var track = wrap.querySelector('[data-hv-reviews-track]');
      var prev = wrap.querySelector('[data-hv-prev]');
      var next = wrap.querySelector('[data-hv-next]');
      if (!track) return;
      var cards = track.children;
      if (!cards.length) return;
      var index = 0;
      function go(i) {
        index = (i + cards.length) % cards.length;
        var card = cards[index];
        track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      if (next) next.addEventListener('click', function () { go(index + 1); });
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
    });
  }

  function initPersonalityToggle() {
    var wraps = document.querySelectorAll('[data-hv-personalidad]');
    wraps.forEach(function (wrap) {
      var buttons = wrap.querySelectorAll('[data-hv-lado]');
      var panels = wrap.querySelectorAll('[data-hv-panel]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var lado = btn.getAttribute('data-hv-lado');
          buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-hv-panel') === lado);
          });
        });
      });
    });
  }

  function initProductGallery() {
    var galleries = document.querySelectorAll('[data-hv-gallery]');
    galleries.forEach(function (gallery) {
      var main = gallery.querySelector('[data-hv-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-hv-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-full');
          var srcset = thumb.getAttribute('data-full-srcset');
          if (src) main.src = src;
          if (srcset) main.srcset = srcset;
          thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        });
      });
    });
  }

  function initVariantPicker() {
    var forms = document.querySelectorAll('[data-hv-product-form]');
    forms.forEach(function (formWrap) {
      var dataEl = formWrap.querySelector('[data-hv-variants-json]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var selects = formWrap.querySelectorAll('[data-hv-option]');
      var idInput = formWrap.querySelector('[data-hv-variant-id]');
      var priceEl = formWrap.querySelector('[data-hv-price]');
      var compareEl = formWrap.querySelector('[data-hv-compare]');
      var submitBtn = formWrap.querySelector('[data-hv-submit]');

      function currentSelection() {
        var vals = [];
        selects.forEach(function (s) { vals.push(s.value); });
        return vals;
      }
      function findVariant(vals) {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === vals[i]; });
        });
      }
      function money(cents) {
        return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
      }
      function update() {
        var variant = findVariant(currentSelection());
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = money(variant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (submitBtn) {
          if (variant.available) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.getAttribute('data-label-add') || 'Añadir al carrito';
          } else {
            submitBtn.disabled = true;
            submitBtn.textContent = submitBtn.getAttribute('data-label-sold-out') || 'Agotado';
          }
        }
      }
      selects.forEach(function (s) { s.addEventListener('change', update); });
      update();
    });
  }

  function initMoleculeSpin() {
    var svgs = document.querySelectorAll('[data-hv-molecule]');
    if (!svgs.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-live', entry.isIntersecting);
      });
    }, { threshold: 0.3 });
    svgs.forEach(function (el) { io.observe(el); });
  }

  function initMobileMenuLogoFix() {
    // no-op placeholder kept for future header tweaks
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCountUp();
    initTiltCards();
    initReviewCarousel();
    initPersonalityToggle();
    initProductGallery();
    initVariantPicker();
    initMoleculeSpin();
    initMobileMenuLogoFix();
  });
})();
